import React, { useRef, useState } from "react";
import themePropTypes from "../theme/theme-prop-types";

const VideoField = ({ field }) => {
  const videoRef = useRef(null);
  const [showPlayButton, setShowPlayButton] = useState(true);

  const conf = field.data;

  // the m3u8 video URL passed down by flowUI doesn't work with the web player, so convert it to a more generic /video
  const videoUrl = conf.m3u8URL.replace("adaptive.m3u8", "video");
  const {
    splashscreenUrl,
    accessibilityDescription,
    accessibility_video_play,
    subtitles
  } = conf;

  const onPlayButtonClicked = () => {
    setShowPlayButton(false);
    videoRef.current.play();
  };

  const onPlaybackStarted = () => {
    setShowPlayButton(false);
  };

  const onPlaybackStopped = () => {
    setShowPlayButton(true);
  };

  return (
    <div className='videoWidget'>
      <div className='videoAspectRatioBox'>
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <video
          aria-label={accessibilityDescription}
          className='videoPlayer'
          controls='controls'
          controlsList='nodownload'
          crossOrigin='anonymous'
          disablePictureInPicture
          poster={splashscreenUrl}
          preload='metadata'
          ref={videoRef}
          style={{ width: "100%" }}
          onPause={onPlaybackStopped}
          onEnded={onPlaybackStopped}
          onPlay={onPlaybackStarted}
        >
          <source src={videoUrl} />
          {subtitles.map(subtitle => (
            <track
              key={`subtitle_${subtitle.languageShortName}`}
              kind='captions'
              label={subtitle.languageLongName}
              src={subtitle.sourceVtt}
              srcLang={subtitle.languageShortName}
            />
          ))}
        </video>
      </div>

      <button
        aria-label={accessibility_video_play}
        className='videoPlayButton'
        label={accessibility_video_play}
        name='Play Video'
        onClick={onPlayButtonClicked}
        style={{ visibility: showPlayButton ? "visible" : "hidden" }}
        type='button'
      >
        {accessibility_video_play}
      </button>
    </div>
  );
};

VideoField.propTypes = themePropTypes.video;

export default VideoField;
